import React, {Component} from '../../lib/react'
import connect from "react-redux/es/connect/connect";
import { Link } from "react-router";

import { savePreviousPath } from "../../actions/optionsStoreActions";

import './linkComponent.less'

class LinkComponent extends Component {
  constructor(props){
    super(props)
    this.state = {}
  }

  handleLink(pathFrom) {
    this.props.savePreviousPath(pathFrom)
  }

  render() {
    const { pathFrom, pathTo, linkClass, isHide } = this.props;

    return (
      <div
        onClick={() => this.handleLink(pathFrom)}
        className={`link-component ${linkClass || ''}`}
      >
        {
          !isHide && (
            <Link className={this.props.className} to={pathTo}>
              {this.props.children}
            </Link>
          )
        }
      </div>

    )
  }
}

export default connect(
  null,
  { savePreviousPath }
)(LinkComponent);



// WEBPACK FOOTER //
// ./src/components/LinkComponent/LinkComponent.js